import { render, staticRenderFns } from "./DomainProjectSelect.vue?vue&type=template&id=b4de6084"
import script from "./DomainProjectSelect.vue?vue&type=script&lang=js"
export * from "./DomainProjectSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports